<template>
  <div class="news-list">
    <div style="float: left;border-radius: 1rem;" class="news-item home-news-card" v-if="screenWidth>540">
      <div class="home-news-card-img" style="width: 100%;background-size: cover;background-repeat: no-repeat;" :style="{'background-image': 'url('+newsList[0].imgUrl+')',}"  @click="goArticleDetail(newsList[0])">

      </div>
      <div style="padding: 2rem 3rem; padding-top: 1rem;" class="news-item-hover" @click="goArticleDetail(newsList[0])">
        <h2 class="news-title">{{ newsList[0].title }}</h2>
        <div class="news-abstract" style="line-height: 2;">
           {{ newsList[0].digest }}
        </div>
        <div v-if="screenWidth<=540"><span class="news-item-time" v-if="newsList[0].createDate">{{ newsList[0].createDate.split(' ')[0].split('-')[1] + '-' + newsList[0].createDate.split(' ')[0].split('-')[2] }}</span>/{{ newsList[0].createDate.split(' ')[0].split('-')[0] }}</div>
        <div style=" display: flex;flex-direction: row;justify-content: space-between;margin-top: 1rem;">
          <span v-if="screenWidth>540">
            <span class="news-item-time" v-if="newsList[0].createDate">{{ newsList[0].createDate.split(' ')[0].split('-')[1] + '-' + newsList[0].createDate.split(' ')[0].split('-')[2] }}</span>/{{ newsList[0].createDate.split(' ')[0].split('-')[0] }}
          </span>
          <span>{{$t('ViewDetails')}} <i class="el-icon-right"></i></span>
        </div>
      </div>
    </div>

    <div style="" class="news-item home-news-card" v-if="screenWidth>540">
      <div class="right-news-list">
        <div class="right-news-list-item news-item-hover" v-for="(news,index) in newsList.filter((items,i)=>i>0 && i<(screenWidth<=540?4:6))" :key="news.id" @click="goArticleDetail(news)">
          <span class="news-item-time" v-if="news.createDate">{{ news.createDate.split(' ')[0].split('-')[1] + '-' + news.createDate.split(' ')[0].split('-')[2] }}</span> / {{ news.createDate.split(' ')[0].split('-')[0] }}
          <div class="news-title" style="font-size: 1.2rem;font-weight: 500;">{{ news.title }}</div>
          <el-divider v-if="index != (screenWidth <= 540? 2:4)"></el-divider>
        </div>
      </div>
    </div>

    <div v-if="screenWidth<=540" style="width:100%;">
      <div style="margin-top: 1rem;background: #ffffff;overflow: hidden;" @click="goArticleDetail(newsList[0])">
        <div style="width: 100%;overflow: hidden;padding:0 1rem;box-sizing:border-box">
          <img :src="newsList[0].imgUrl" alt="" width="100%" style="border-radius: 0.8rem;box-sizing:border-box">
        </div>
        <div style="background: #ffffff;padding: 0rem 1rem;">
          <h2 class="text-max-1">{{ newsList[0].title }}</h2>
          <span class="news-item-time" v-if="newsList[0].createDate">{{ newsList[0].createDate.split(' ')[0].split('-')[1] + '-' + newsList[0].createDate.split(' ')[0].split('-')[2] }}</span>/{{ newsList[0].createDate.split(' ')[0].split('-')[0] }}
          <div class="text-max-2" style="font-size: 1.2rem;font-weight: 400;margin-top:1rem ;line-height: 2;">{{ newsList[0].digest }}</div>
          <el-divider></el-divider>
        </div>
      </div>
      <div class="right-news-list1" style="background: #ffffff;border-radius: 2rem;padding:0rem 1rem;padding-bottom: 0;">
        <div class="right-news-list-item1 news-item-hover" v-for="(news,index) in newsList.filter((items,i)=>i>0 && i<6)" :key="news.id" @click="goArticleDetail(news)">
          <span class="news-item-time" v-if="news.createDate">{{ news.createDate.split(' ')[0].split('-')[1] + '-' + news.createDate.split(' ')[0].split('-')[2] }}</span> / {{ news.createDate.split(' ')[0].split('-')[0] }}
          <div class="news-title" style="font-size: 1.2rem;font-weight: 500;">{{ news.title }}</div>
          <el-divider v-if="index != 4"></el-divider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth'])
  },
  props: {
    newsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      maxNum: 6,
    };
  },
  watch: {
  },
  mounted() {
    console.log("newsList", this.newsList);

  },
  methods: {
    goArticleDetail(news) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: news.id,
		  fundId: 1
        },
      });
    },
    getWindowInfo() {
      if (this.screenWidth < 500) {
        this.maxNum = 4
      } else {
        this.maxNum = 6
      }
    },
  },
};
</script>

<style scoped lang="less">
.news-list {
  display: flex;
  gap: 2%;
  padding: 2rem 5%;
  padding-top: 1rem;
  background: white;
  flex-direction: row;
  justify-content: space-between;
}
.news-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-abstract {
  overflow: hidden;
  line-height: 2rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-item {
  float: left;
  border-radius: 1rem;
  width: 49%;
  background-color: #f6f6f6;
  overflow: hidden;
}
.right-news-list {
  padding: 2rem 3rem;
  padding-bottom: 0;
}
.right-news-list-item1 {
  // height: 7rem;
  overflow: hidden;
  line-height: 2rem;
  // .el-divider--horizontal {
  //   margin-top: 1rem !important;
  // }
}
.right-news-list-item {
  height: 7rem;
  overflow: hidden;
  line-height: 2rem;
  .el-divider--horizontal {
    margin-top: 1rem !important;
  }
}
.news-item-hover:hover {
  color: #aa221d !important;
  cursor: pointer;
}
.news-item-time {
  font-size: 1.2rem;
  font-weight: 500;
}
.home-news-card {
  height: 36rem;
  .home-news-card-img {
    height: 21rem;
  }
}
</style>